import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { pollKeys } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/api";
import { MemberRow } from "@circle-react/components/PostsV3/PostViewListItem/PostLikesModal/MemberRow";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useInfiniteQueryWrapper } from "@circle-react/hooks/reactQuery/useInfiniteQueryWrapper";
import { Modal } from "@circleco/compass/components/Modal";
import { flatten } from "lodash";
import { useMemo } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { t } from "@/i18n-js/instance";
import type { CompassModalProps } from "@/react/components/SettingsApp/CompassCompat/modalHelpers";

import type { PollVoteListModalProps } from "./types";

export const PollVoteListModalComponent = ({
  pollOptionId,
  pollId,
  pollValue,
  percentage,
  open,
  onOpenChange,
}: PollVoteListModalProps & CompassModalProps) => {
  const scrollTargetId = `poll-vote-list-modal-${pollId}-${pollOptionId}`;
  const { data, isLoading, fetchNextPage, hasNextPage, mapPages } =
    useInfiniteQueryWrapper(
      internalApi.polls.voteList({
        pollId,
        pollOptionId,
        params: {
          per_page: 15,
        },
      }),
      { enabled: !!pollId && !!pollOptionId && open },
      pollKeys.voteList(pollId, pollOptionId),
    );

  const votes = useMemo(
    () => flatten(mapPages((page: any) => page.records)),
    [mapPages],
  );
  const totalVotesCount = data?.pages[0]?.count;
  const voteStats =
    totalVotesCount == null
      ? undefined
      : `${percentage}% ${t("separator_dot")} ${t(
          "tiptap.extensions.poll.votes",
          {
            count: totalVotesCount,
          },
        )}`;

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header
          title={pollValue}
          description={isLoading ? undefined : voteStats}
        />
        <Modal.Body customLayout>
          {isLoading ? (
            <LoaderRow />
          ) : (
            <div
              id={scrollTargetId}
              className="overflow-y-auto sm:max-h-[400px]"
            >
              <InfiniteScroll
                scrollThreshold={0.75}
                next={fetchNextPage}
                hasMore={hasNextPage || false}
                loader={<LoaderRow />}
                scrollableTarget={scrollTargetId}
                dataLength={votes.length}
                className="flex flex-col gap-4"
              >
                {votes.map(vote => (
                  <MemberRow
                    key={vote.id}
                    member={vote.community_member}
                    onNavigate={() => onOpenChange(false)}
                  />
                ))}
              </InfiniteScroll>
            </div>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
